'use client';
import { createContext, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';

interface AnalyticsContextType {
  trackEvent: (eventName: string, eventParams?: Record<string, any>) => void;
}

export const AnalyticsContext = createContext<AnalyticsContextType>({
  trackEvent: () => {},
});

export const AnalyticsProvider = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (analytics && pathname) {
      const url = `${pathname}${searchParams.toString() ? `?${searchParams}` : ''}`;
      logEvent(analytics, 'page_view', {
        page_path: url,
        page_title: document.title,
        page_location: window.location.href,
        is_homepage: pathname === '/',
      });
    }
  }, [pathname, searchParams]);

  const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    }
  };

  return (
    <AnalyticsContext.Provider value={{ trackEvent }}>
      {children}
    </AnalyticsContext.Provider>
  );
};